import React from 'react'
import PropTypes from 'prop-types'

import EmployeeCard from 'components/EmployeeCard'
import FluidImage from 'components/FluidImage'
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton'
import Link, { LINK_THEMES } from 'components/Link'

import EmployeeType from 'types/EmployeeType'

class EmployeeBlockLarge extends React.PureComponent {
    static propTypes = {
        employee: PropTypes.shape(EmployeeType).isRequired,
        labels: PropTypes.shape({
            contactMeOrMyColleagues: PropTypes.string.isRequired,
            contactLabel: PropTypes.string.isRequired,
            viewAllEmployees: PropTypes.string.isRequired,
        }).isRequired,
        image: PropTypes.shape({
            url: PropTypes.string
        }),
        url: PropTypes.string.isRequired,
    }

    render() {
        const {
            employee,
            labels,
            image,
            url,
        } = this.props

        return (
            <div className="employee-block-large">
                <div className="employee">
                    <p className="contact-text h3">{labels.contactMeOrMyColleagues}</p>
                    <EmployeeCard
                        {...employee}
                        negative={true}
                    />
                    <div className="actions">
                        <LinkButton 
                            additionalAttributes={{
                                "data-type": "employee",
                                "data-name": employee.name
                            }}
                            theme={LINK_BUTTON_THEMES.darkFilled}
                            url={employee.url}
                            text={labels.contactLabel}
                        />
                        {url && (
                            <Link url={url} text={labels.viewAllEmployees} theme={LINK_THEMES.lightTotal} />
                        )}
                    </div>
                </div>
                <FluidImage
                    className="image"
                    size={660}
                    {...image}
                />
            </div>
        )
    }
}

export default EmployeeBlockLarge
